import { render, staticRenderFns } from "./homeMain.vue?vue&type=template&id=25b21f7d&"
import script from "./homeMain.vue?vue&type=script&lang=js&"
export * from "./homeMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/multiPage/homeMain.vue"
export default component.exports